import { render, staticRenderFns } from "./college-first.vue?vue&type=template&id=611ead71&scoped=true"
import script from "./college-first.vue?vue&type=script&lang=js"
export * from "./college-first.vue?vue&type=script&lang=js"
import style0 from "./college-first.vue?vue&type=style&index=0&id=611ead71&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611ead71",
  null
  
)

export default component.exports